import { Injectable } from '@angular/core';
import { XpoBoardApiAction } from './models/board-api-actions.model';
import { XpoBoardApiDispatcherBase } from './models/board-api-dispatcher.model';

@Injectable()
export class XpoBoardApiDispatcherService extends XpoBoardApiDispatcherBase<XpoBoardApiAction> {}
